import React, { PureComponent } from 'react';
import {
	PieChart, Pie, Cell,
} from 'recharts';
import uuid from 'uuid';

import { StyledPieChartWithCustomizedLabel, CustomColorSquare, RenderStyleSVG } from './style/StyledPieChartWithCustomizedLabel';

import { SelectColor } from '../../../../services/reports';

import { ReactComponent as IconMan } from '../../GenderOrAgesPerformance/images/man.svg';
import { ReactComponent as IconWoman } from '../../GenderOrAgesPerformance/images/woman.svg';

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
	cx, cy, midAngle, innerRadius, outerRadius, percent,
}) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text
			x={x}
			y={y}
			fill="white"
			textAnchor={x > cx ? 'start' : 'end'}
			dominantBaseline="central"
		>
			{`${(percent * 100).toFixed(0)}%`}
		</text>
	);
};

export default class Example extends PureComponent {
	render() {
		const {
			data, typeChart, channel, alias,
		} = this.props;

		return (
			<StyledPieChartWithCustomizedLabel className={typeChart}>
				<PieChart width={300} height={300}>
					<Pie
						data={data}
						cx={200}
						cy={200}
						labelLine={false}
						label={renderCustomizedLabel}
						outerRadius={80}
						fill="#8884d8"
						dataKey="value"
					>
						{/* eslint-disable-next-line react/no-array-index-key */}
						{data.map((entry, index) => <Cell key={`cell-${index}`} fill={SelectColor(channel, entry.name ? (entry.name) : entry.title, alias)} />)}
					</Pie>
				</PieChart>

				{(typeChart === 'GenderOrAgesPerformance') ? (
					<div className="legend legend-people mb-3">
						<div className="men">
							<RenderStyleSVG channel={channel}>
								<IconMan width={30} height={40} className="icon-men" />
							</RenderStyleSVG>
							<span>Homens</span>
						</div>

						<div className="woman">
							<RenderStyleSVG channel={channel}>
								<IconWoman width={30} height={40} className="icon-women" />
							</RenderStyleSVG>
							<span>Mulheres</span>
						</div>
					</div>
				) : (
					<div className="legend">
						{data.map(element => (
							<div key={uuid.v4()}>
								<CustomColorSquare color={SelectColor(channel, element.title, alias)} />
								{element.title}
							</div>
							))}
					</div>
					)}
			</StyledPieChartWithCustomizedLabel>
		);
	}
}
